import { Component, forwardRef, HostBinding, Inject, Input, OnInit } from '@angular/core';
import { ErrorMessages } from '../../common/constants';
import { Alert, AlertDefinitionRemedy, AlertRemedySelection } from '../../model';
import { AlertService } from '../shared/alert.service';
import { AuthenticationService } from '../../service/authentication.service';
import { ContextService } from '../../service/context.service';
import { AbstractContextService } from '../../shared/class/abstract-context-service.class';
import { ErrorUtility } from '../../utility/error-utility';
import { ThingTroubleshootingWidgetService } from '../../widget/thing-troubleshooting/thing-troubleshooting-widget.service';

@Component({
    selector: 'event-details-troubleshooting',
    template: require('./event-details-troubleshooting.component.html'),
    providers: [
        ThingTroubleshootingWidgetService,
        { provide: AbstractContextService, useExisting: ContextService }
    ]
})
export class EventDetailsTroubleshootingComponent implements OnInit {

    @Input() alert: Alert;

    @HostBinding('style.display') get display(): string {
        return this.hasContent() ? 'block' : 'none';
    }

    remedies: AlertDefinitionRemedy[] = [];
    timezone: string;
    error: string;

    constructor(
        @Inject(forwardRef(() => ThingTroubleshootingWidgetService)) private thingTroubleshootingWidgetService: ThingTroubleshootingWidgetService,
        @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
        @Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService,
        @Inject(forwardRef(() => ContextService)) private contextService: ContextService
    ) { }

    ngOnInit(): void {
        this.timezone = this.contextService.getTimezone();
        this.loadRemedies();
    }

    hasContent(): boolean {
        return !!this.alert && (!!this.alert.technicalDescription || this.hasRemedies());
    }

    hasRemedies(): boolean {
        return !!this.alert?.alertDefinitionId && this.remedies?.length > 0;
    }

    updateSelections(selections: AlertRemedySelection[]): void {
        const timestamp = new Date().getTime();
        const userId = this.authenticationService.getUser().id;
        selections.forEach(selection => {
            selection.userId = userId;
            selection.timestamp = timestamp;
        });
        this.error = null;
        this.alertService.updateSelection(this.alert, selections)
            .then(() => this.alert.alertRemedySelections = selections)
            .catch(err => this.error = ErrorUtility.getMessage(err, ErrorMessages.SAVE_DATA_ERROR));
    }

    private loadRemedies(): void {
        if (!this.alert?.alertDefinitionId) {
            return;
        }
        this.thingTroubleshootingWidgetService.getRemediesByAlertDefinitionId(this.alert.alertDefinitionId)
            .then(remedies => this.remedies = remedies || []);
    }
}
